import { render, staticRenderFns } from "./HelpCenterFaq.vue?vue&type=template&id=3740850f"
import script from "./HelpCenterFaq.vue?vue&type=script&lang=js"
export * from "./HelpCenterFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports